import {
  observer,
  useTranslation,
  useLocation,
  useNavigate,
  gsap,
  ScrollTrigger,
  Dropdown,
  Button,
} from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
import { siteConfig } from "../../config/site.js";
import { ArchivedVideo } from "../../platform/ArchivedVideo.jsx";
import * as AnalyticsContext from "../../analytics/AnalyticsProvider.jsx";
import * as UseMediaQueryModule from "../../hooks/useMediaQuery.js";
import * as jsxRuntime from "react/jsx-runtime";
import { lineSlotClass } from "./ParticleText.jsx";
import { lineClass } from "./ParticleText.jsx";
import { lineSizerClass } from "./ParticleText.jsx";
import { lineTypingClass } from "./ParticleText.jsx";
import { HeroActions } from "./HeroActions.jsx";
import { ParticleText } from "./ParticleText.jsx";
import { heroModelLinks } from "../../content/hero.js";
var Hero = observer(function () {
  let { t: translate, i18n: i18n } = useTranslation(),
    i = (0, React.useRef)(null),
    o = (0, React.useRef)(null),
    r = (0, React.useRef)(null),
    l = (0, React.useRef)(null),
    s = (0, React.useRef)(null),
    c = (0, React.useRef)(null),
    d = (0, React.useRef)(null),
    { pathname: pathname } = useLocation(),
    m = useNavigate(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    [M, y] = (0, React.useState)(false),
    N = (0, UseMediaQueryModule.useMediaQuery)(
      "(hover: none) and (pointer: coarse)",
    );
  (0, React.useEffect)(() => {
    y(false);
  }, [pathname, i18n.language]);
  let b = (0, UseMediaQueryModule.useMediaQuery)("(max-width: 900px)"),
    [k, T] = (0, React.useState)(false);
  (0, React.useEffect)(() => {
    T(true);
  }, []);
  let C = (0, UseMediaQueryModule.useMediaQuery)("(max-width: 855px)"),
    w = (0, React.useCallback)(() => {
      let e = d.current;
      e && (e.readyState > 0 && (e.currentTime = 0), e.play().catch(() => {}));
    }, []),
    A = (0, React.useCallback)((e) => {
      ((d.current = e), e && ((e.muted = true), e.play().catch(() => {})));
    }, []);
  return (
    (0, React.useEffect)(() => {
      w();
      let e = () => {
        "visible" === document.visibilityState && w();
      };
      return (
        document.addEventListener("visibilitychange", e),
        () => document.removeEventListener("visibilitychange", e)
      );
    }, [pathname, w]),
    (0, React.useEffect)(() => {
      let e = () => {
        let e = d.current;
        if (!e || !e.paused) return;
        let t = Number.isFinite(e.duration) ? e.duration : 1 / 0;
        e.currentTime >= t - 0.1 ||
          ((e.muted = true), e.play().catch(() => {}));
      };
      return (
        window.addEventListener("focus", e),
        window.addEventListener("resize", e),
        document.addEventListener("pointerdown", e),
        () => {
          (window.removeEventListener("focus", e),
            window.removeEventListener("resize", e),
            document.removeEventListener("pointerdown", e));
        }
      );
    }, []),
    (0, React.useEffect)(() => {
      let t = i.current,
        n = o.current,
        a = r.current;
      if (!t || !n) return;
      let l = translate("home.hero.subtitle1"),
        s = translate("home.hero.subtitle"),
        c = false,
        d = [],
        u = (e, t) => {
          let i = window.setTimeout(() => {
            c || e();
          }, t);
          d.push(i);
        };
      (a &&
        gsap.set(a, {
          opacity: 0,
        }),
        (t.textContent = ""),
        (n.textContent = ""));
      let p = (e, t, i, n, o = false) => {
          let a = o && t.endsWith("_") ? t.slice(0, -1) : t,
            r = document.createElement("span");
          ((r.className = "Hero_heroTypingCursor__nV0pL"), e.append(r));
          let l = 0,
            s = () => {
              if (!c)
                if (l < a.length)
                  (e.insertBefore(document.createTextNode(a[l]), r),
                    l++,
                    u(s, i + (10 * Math.random() - 5)));
                else {
                  if ((r.remove(), o)) {
                    let t = document.createElement("span");
                    ((t.className = "Hero_heroBlinkUnderscore__nV0pL"),
                      (t.textContent = "_"),
                      e.append(t));
                  }
                  n?.();
                }
            };
          s();
        },
        m = () => {
          u(() => {
            p(t, l, 50, () => {
              u(() => {
                p(
                  n,
                  s,
                  60,
                  () => {
                    a &&
                      gsap.to(a, {
                        opacity: 1,
                        duration: 0.3,
                        ease: "power2.out",
                      });
                  },
                  true,
                );
              }, 120);
            });
          }, 300);
        };
      return (
        document.fonts?.ready
          ? document.fonts.ready.then(() => {
              c || m();
            })
          : m(),
        () => {
          for (let e of ((c = true), d)) clearTimeout(e);
        }
      );
    }, [i18n.language, translate]),
    (0, React.useEffect)(() => {
      let e = l.current,
        t = s.current;
      if (!e) return;
      let i = () => {
        ((e.style.width = ""),
          (e.style.maxWidth = ""),
          (e.style.marginLeft = ""),
          (e.style.marginRight = ""),
          (e.style.borderRadius = ""),
          t && (t.style.height = ""));
      };
      if (!k || C) return void i();
      gsap.set(e, {
        borderRadius: 24,
      });
      let n = t ? t.getBoundingClientRect().height : 0,
        o = e.getBoundingClientRect().width,
        a = (function (e) {
          let t = e.parentElement;
          for (; t;) {
            if (/(auto|scroll)/.test(getComputedStyle(t).overflowY)) return t;
            t = t.parentElement;
          }
        })(e),
        r = a ? a.clientWidth : window.innerWidth,
        c = {
          p: 0,
        },
        d = false,
        u = gsap.to(c, {
          p: 1,
          ease: "none",
          scrollTrigger: {
            trigger: e,
            scroller: a,
            start: 0,
            end: "top 10%",
            scrub: 0.3,
          },
          onUpdate: () => {
            let { p: a } = c;
            if (0 === a) {
              (i(),
                t && (n = t.getBoundingClientRect().height),
                (o = e.getBoundingClientRect().width),
                (d = false));
              return;
            }
            d || ((d = true), w());
            let l = o + a * (r - o),
              s = e.parentElement.clientWidth;
            ((e.style.width = `${l}px`),
              (e.style.maxWidth = `${r}px`),
              (e.style.marginLeft = `${(s - l) / 2}px`),
              (e.style.marginRight = "0"),
              (e.style.borderRadius = `${24 * (1 - a)}px`),
              t && (t.style.height = `${n + a * (window.innerHeight - n)}px`));
          },
        }),
        p = () => ScrollTrigger.refresh();
      return (
        window.addEventListener("load", p),
        document.fonts?.ready.then(p),
        () => {
          (window.removeEventListener("load", p),
            u.scrollTrigger?.kill(),
            u.kill(),
            i());
        }
      );
    }, [w, k, C]),
    (
      <jsxRuntime.Fragment>
        <section className={"Hero_hero__nV0pL"}>
          <div className={"Hero_heroContent__nV0pL"}>
            <div className={"Hero_heroText__nV0pL"}>
              <div className={lineSlotClass}>
                <p className={`${lineClass} ${lineSizerClass}`}>
                  {translate("home.hero.subtitle1")}
                </p>
                <p
                  ref={i}
                  aria-hidden={"true"}
                  className={`${lineClass} ${lineTypingClass}`}
                />
              </div>
              <div className={lineSlotClass}>
                <p className={`${lineClass} ${lineSizerClass}`}>
                  {translate("home.hero.subtitle")}
                </p>
                <p
                  ref={o}
                  aria-hidden={"true"}
                  className={`${lineClass} ${lineTypingClass}`}
                />
              </div>
            </div>
            <div ref={r} className={"Hero_heroButtonsWrap__nV0pL"}>
              <HeroActions />
            </div>
          </div>
        </section>
        <div className={"Hero_heroBannerWrap__nV0pL"}>
          <div
            ref={l}
            className={"Hero_heroBanner__nV0pL"}
            onClick={() => {
              (track("track", "home_hero_click", {
                title: "video_pro",
              }),
                m("/models/mimo-v2.6-pro"));
            }}
          >
            <div ref={s} className={"Hero_heroBannerShader__nV0pL"}>
              <picture>
                <source
                  media={"(max-width: 900px)"}
                  srcSet={siteConfig.hero.mobilePoster}
                />
                <img
                  className={"Hero_heroBannerStill__nV0pL"}
                  src={siteConfig.hero.poster}
                  alt={""}
                  fetchPriority={"high"}
                />
              </picture>
              {k && !b && (
                <ArchivedVideo
                  ref={A}
                  autoPlay={true}
                  muted={true}
                  playsInline={true}
                  poster={siteConfig.hero.poster}
                  src={siteConfig.hero.video}
                />
              )}
              <ParticleText
                text={"Astra"}
                onLayout={(e) => {
                  let t = c.current;
                  t && (t.style.top = `${e + 14}px`);
                }}
              />
            </div>
          </div>
          <div ref={c} className={"Hero_versionBtnWrap__nV0pL"}>
            <Dropdown
              open={M}
              onOpenChange={y}
              trigger={N ? ["click"] : ["hover"]}
              placement={"bottom"}
              mouseLeaveDelay={0.12}
              overlayClassName={"Hero_versionDropdownOverlay__nV0pL"}
              popupRender={() => (
                <div className={"Hero_versionDropdown__nV0pL"}>
                  <div className={"Hero_versionDropdownInner__nV0pL"}>
                    {heroModelLinks.map((e) => (
                      <a
                        key={e.href}
                        href={e.href}
                        target={"_blank"}
                        rel={"noopener noreferrer"}
                        className={"Hero_versionDropdownItem__nV0pL"}
                        onClick={() =>
                          track("track", "home_hero_click", {
                            title: e.trackTitle,
                          })
                        }
                      >
                        {e.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            >
              <Button className={"Hero_versionBtn__nV0pL"} aria-expanded={M}>
                {translate("home.hero.versionBtn")}
              </Button>
            </Dropdown>
          </div>
        </div>
      </jsxRuntime.Fragment>
    )
  );
});
export { Hero };
